import React, { useState } from "react";
import { Layout, Popover, Button } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import languageData from "./languageData";
import { switchLanguage, toggleCollapsedSideNav } from "../../appRedux/actions/Setting";
import SearchBox from "components/SearchBox";
import UserInfo from "components/UserInfo";
import AppNotification from "components/AppNotification";
import MailNotification from "components/MailNotification";
import Auxiliary from "util/Auxiliary";

import TeachersOperations from "./../../aws/gql/TeachersOperations"
import { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } from "../../constants/ThemeSetting";
import { useDispatch, useSelector } from "react-redux";
import ShareAppLink from "../../components/share/ShareAppLink";
import { clickedOnInviteStudent } from "../../analytics";
import { NotificationManager } from "react-notifications";

const { Header } = Layout;

const Topbar = () => {
  //TODO: add school name
  //TODO: account inactive banner
  const { locale, width, navCollapsed, navStyle } = useSelector(({ settings }) => settings);
  const { teacher_details } = useSelector(({ dashboard }) => dashboard);
  const { searchText, setSearchText } = useState('');
  const [showShare, setShowShare] = useState(false)
  const [sendInviteEmail,setSendInviteEmail]  =useState(false);
  const dispatch = useDispatch();
  const schoolName = teacher_details ? teacher_details.schoolName : ""
  const languageMenu = () => (
    <CustomScrollbars className="gx-popover-lang-scroll">
      <ul className="gx-sub-popover">
        {languageData.map(language =>
          <li className="gx-media gx-pointer" key={JSON.stringify(language)} onClick={(e) =>
            dispatch(switchLanguage(language))
          }>
            <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
            <span className="gx-language-text">{language.name}</span>
          </li>
        )}
      </ul>
    </CustomScrollbars>);

  const updateSearchChatUser = (evt) => {
    setSearchText(evt.target.value);
  };
  const renderInviteButton = () => (<Button 
    loading={sendInviteEmail}
    style={{ background: "orange", color: "#FFF" }} onClick={async () => {
    // setShowShare(true);
    try {
      setSendInviteEmail(true)
      const response = await TeachersOperations.InviteStudent();
      console.log(response)
      setTimeout(() => {
        setSendInviteEmail(false)
        NotificationManager.info(
          <h3>
            We have sent you sms and email with instructions for inviting students.
        </h3>
        );
      }, 100);
    } catch (error) {
      setTimeout(() => {
        setSendInviteEmail(false);
        NotificationManager.error(
          <h3>
            {error.message}
          </h3>
        );
      }, 100);
    }
    clickedOnInviteStudent()
  }}>Invite Students</Button>)
  return (
    <Header>
      {navStyle === NAV_STYLE_DRAWER || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ?
        <div className="gx-linebar gx-mr-3">
          <i className="gx-icon-btn icon icon-menu"
            onClick={() => {
              dispatch(toggleCollapsedSideNav(!navCollapsed));
            }}
          />
        </div> : null}
      <Link to="/" className="gx-d-block gx-d-lg-none gx-pointer">
        <img alt="" src={require("assets/images/w-logo.png")} /></Link>

      <ul className="gx-header-notifications gx-ml-auto">
        <li className="gx-notify gx-notify-search gx-d-inline-block gx-d-lg-none">
        </li>
        {width >= TAB_SIZE ? <Auxiliary>
          <div style={{ padding: 4 }} className="topbar_school_name"><h3 className="gx-avatar-name" style={{ color: "orange" }}>{schoolName}</h3></div>
          {renderInviteButton()}
        </Auxiliary> :
          <Auxiliary>
            {renderInviteButton()}
            <li className="gx-user-nav"><UserInfo teacher_details={teacher_details} /></li>
          </Auxiliary>
        }
      </ul>
      <ShareAppLink showModal={showShare} onClose={() => { setShowShare(false) }} onSubmit={(status) => {
        setShowShare(false)
      }}></ShareAppLink>
    </Header>
  );
};

export default Topbar;
